import httpClient from "@/config/httpClient";
import { uiStore, userStore } from "@/mobx/rootStore";
import { routesList } from "@/routesList";

export async function logout({ redirect = routesList.login.path }) {
	httpClient.headers.Authorization = "";
	userStore.reset();
	uiStore.reset();

	if (redirect) {
		window.location.href = redirect;
	}
}
